import { InfoOutlined } from 'components/icons';
import { Alert } from 'components/ui/alert';
import { FC, PropsWithChildren } from 'react';

/**
 * Compact single-line info alert for "totals limit exceeded" messages in the totals slot. It must stay
 * within TableTotalsWrapper's min-height, so swapping between the totals text and this alert doesn't
 * move the table below (CLS): 2px of padding and a 1px border around one 20px line.
 */
const TotalsLimitAlert: FC<PropsWithChildren> = ({ children }) => (
    <Alert className="bg-info/8 text-foreground rounded-md border-transparent py-0.5 pr-4 pl-3 font-semibold has-[>svg]:gap-x-2">
        <InfoOutlined className="text-info! size-[18px]" />
        {children}
    </Alert>
);

export default TotalsLimitAlert;
